import { breakpoints } from '@/constants/breakpoints'
import { lightTheme } from '@/styles/unistyles-theme'
import { UnistylesRegistry } from 'react-native-unistyles'

UnistylesRegistry.addBreakpoints(breakpoints).addThemes({ light: lightTheme })
